export { default } from './Buy';
